/**
 * Used to bring array of objects in options additional field
 * this MUST match with the field created in the DB
 */
export const OPTION_FIELD_NAME = 'Options';
export const OPTION_FIELD_OBJECT_NAME = 'Options';
